export const useMenu = ({ t }: any) => (window as any).menu;
